import { Box, Typography, useTheme } from "@mui/material"
import { useEffect, useRef, useState } from "react"
import { useSpring, animated } from "react-spring"

export const Motd = ({ motd }: { motd: string }) => {
  const theme = useTheme()
  const containerRef = useRef<HTMLDivElement>(null)
  const textRef = useRef<HTMLDivElement>(null)
  const [containerWidth, setContainerWidth] = useState(0)
  const [textWidth, setTextWidth] = useState(0)
  const [scrolling] = useSpring(
    {
      from: { transform: `translateX(${containerWidth}px)` },
      to: { transform: `translateX(${-textWidth}px)` },
      config: { duration: (containerWidth + textWidth) * 8 },
      reset: false,
      loop: true,
    },
    [containerWidth, textWidth],
  )

  useEffect(() => {
    const measure = () => {
      setContainerWidth(containerRef.current?.clientWidth || 0)
      setTextWidth(textRef.current?.scrollWidth || 0)
    }

    measure()
    const observer = new ResizeObserver(measure)
    if (containerRef.current) observer.observe(containerRef.current)
    if (textRef.current) observer.observe(textRef.current)
    return () => observer.disconnect()
  }, [])

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.element.motd?.background || undefined,
        color: theme.palette.element.motd?.color || theme.palette.text.primary,
        py: 1,
        width: "100%",
      }}
    >
      <Box ref={containerRef} sx={{ width: "100%", overflow: "hidden" }}>
        <animated.div
          ref={textRef}
          style={{
            ...scrolling,
            width: "max-content",
            visibility: containerWidth && textWidth ? "visible" : "hidden",
          }}
        >
          <Typography variant="body1" fontWeight="bold" fontSize="1.2rem" whiteSpace="pre-wrap">
            {motd}
          </Typography>
        </animated.div>
      </Box>
    </Box>
  )
}
